import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import { useBmsSaleRoDetailModel } from '../bmsBillSaleRo/bmsBillSaleRoModel';
import { IPurchasePoFields, IDetailList } from './bmsBillPurchasePoType';
import { purchasePoService } from './bmsBillPurchasePoService';

export type IVrmPlanDescType = {
	numAll: number;
	itemNumAll: number;
	totalAll: number;
	[key: string]: any;
};
export const useBmsPurchasePoDetailsModel = createModel(function () {
	const initDesc = {
		numAll: 0, //数量
		itemNumAll: 0, //项数
		totalAll: 0, //总计
	};
	const { getBmsTreeNodeName } = useBmsSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<IPurchasePoFields>({});
	//查看详情列表
	const [detailLookList, setDetailLookList] = useState<IDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<IVrmPlanDescType>(initDesc);

	useEffect(() => {
		let newDesc: IVrmPlanDescType = { ...initDesc };
		detailLookList &&
			detailLookList.forEach((item) => {
				newDesc.numAll += Number(item.num);
				newDesc.totalAll += Number(item.num) * Number(item.price);
			});
		newDesc.itemNumAll = detailLookList && detailLookList.length;
		setLookDesc(newDesc);
	}, [detailLookList]);

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await purchasePoService.one(id);
		if (retData) {
			const { details, ...from } = retData;
			setDetailLookForm({
				...from,
				purchaseTypeName: getBmsTreeNodeName(from.purchaseTypeCode as string),
				supplierTypeName: getBmsTreeNodeName(from.supplierTypeCode as string),
				materialTypeName: getBmsTreeNodeName(from.materialTypeCode as string),
				payType: getBmsTreeNodeName(from.payType as string),
				payMethodName: getBmsTreeNodeName(from.payMethodName as string),
				deliveryMethod: getBmsTreeNodeName(from.deliveryMethod as string),
				invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
			});
			setDetailLookList((details as IDetailList[]) ?? []);
		}
	};

	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookList([]);
		setDetailLookForm({});
	};

	return {
		detailLookForm,
		detailLookList,
		lookDesc,
		setDetailLookForm,
		setDetailLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
